import { t } from "@lingui/macro";
import { useEffect, useState } from "react";

import {
  Box,
  HStack,
  Text,
} from "@whoosh/design-system/src/components/primitive";
import { getUnlocksIn, getUnlocksInValues } from "@whoosh/utilities/src/dates";

import { getLiftAtForServerTimeOffset } from "../../../../../Common/utils/serverTimeOffset";

export const RestrictionBlockFooter = ({
  unlocksAt,
  serverTimeOffsetMs,
}: {
  unlocksAt?: string | null;
  serverTimeOffsetMs?: number | null;
}) => {
  const [unlocksInString, setUnlocksInString] = useState<string | null>(null);

  useEffect(() => {
    if (unlocksAt) {
      const adjustedUnlocksAt = getLiftAtForServerTimeOffset(
        unlocksAt,
        serverTimeOffsetMs
      );
      const unlocksInValue = getUnlocksIn(adjustedUnlocksAt);
      setUnlocksInString(unlocksInValue);

      const interval = setInterval(() => {
        const adjustedUnlocksAt = getLiftAtForServerTimeOffset(
          unlocksAt,
          serverTimeOffsetMs
        );
        const unlocksInValue = getUnlocksIn(adjustedUnlocksAt);
        setUnlocksInString(unlocksInValue);
      }, 1000);

      return () => {
        clearInterval(interval);
      };
    } else {
      setUnlocksInString(null);
    }
  }, [unlocksAt, serverTimeOffsetMs]);

  const getUnlocksInVariant = () => {
    if (unlocksAt) {
      const adjustedUnlocksAt = getLiftAtForServerTimeOffset(
        unlocksAt,
        serverTimeOffsetMs
      );
      const { daysLeft, hoursLeft, minutesLeft, secondsLeft } =
        getUnlocksInValues(adjustedUnlocksAt);
      if (!!daysLeft && !!hoursLeft) return "mainBaseMedium";
      else if (!!minutesLeft || !!secondsLeft) return "mainTitle2";
      else return "mainTitle2";
    }
  };

  return unlocksInString ? (
    <Box mt={4} testID="restriction-countdown-footer">
      <HStack alignItems="flex-end" justifyContent="space-between">
        <Text variant="mainBaseMedium">{t`Opens: `}</Text>
        <Text
          variant={getUnlocksInVariant()}
          testID="restriction-countdown-value"
        >
          {unlocksInString || ""}
        </Text>
      </HStack>
    </Box>
  ) : null;
};
